import { useEntityPageContext } from './EntityContext';

/** The children graph, given the source's own nav as `as`. */
const EntityGraphNav = ({
    as: GraphNav,
    categoryId,
    exportEntity,
    ...rest
}) => {
    const { entity, entityId, country, name, exportName } =
        useEntityPageContext();

    return (
        <GraphNav
            ids={entity ? entity.children : []}
            countryId={country ? country.id : null}
            categoryId={categoryId === undefined ? entityId : categoryId}
            filename={exportName(
                'graph-nav',
                exportEntity === undefined ? {} : { entity: exportEntity },
            )}
            name={name}
            {...rest}
        />
    );
};

export default EntityGraphNav;
